export type TaxVariant = 'both' | 'accommodation' | 'bath'

export const getTaxVariant = (
  collectAccommodationTaxOnSite: boolean,
  collectBathTaxOnSite: boolean
): TaxVariant | null => {
  if (collectAccommodationTaxOnSite && collectBathTaxOnSite) {
    return 'both'
  }

  if (collectAccommodationTaxOnSite) {
    return 'accommodation'
  }

  if (collectBathTaxOnSite) {
    return 'bath'
  }

  return null
}
